const TOKEN_KEY = 'denholm_token'
const USER_KEY = 'denholm_user'

const isBrowser = typeof window !== 'undefined' && typeof window.localStorage !== 'undefined'

const getToken = () => {
  console.log(isBrowser)
   
  if (!isBrowser) return ''
  return window.localStorage.getItem(TOKEN_KEY) || ''
}

const setToken = (token) => {
  if (!isBrowser) return
  const value = token ? String(token) : ''
  if (value) {
    window.localStorage.setItem(TOKEN_KEY, value)
  } else {
    window.localStorage.removeItem(TOKEN_KEY)
  }
}

const clearToken = () => {
  if (!isBrowser) return
  window.localStorage.removeItem(TOKEN_KEY)
}

const getUser = () => {
  if (!isBrowser) return null
  const raw = window.localStorage.getItem(USER_KEY)
  if (!raw) return null
  try {
    return JSON.parse(raw)
  } catch (error) {
    return null
  }
}

const setUser = (user) => {
  if (!isBrowser) return
  if (!user) {
    window.localStorage.removeItem(USER_KEY)
    return
  }
  const value = typeof user === 'string' ? user : JSON.stringify(user)
  window.localStorage.setItem(USER_KEY, value)
}

const clearUser = () => {
  if (!isBrowser) return
  window.localStorage.removeItem(USER_KEY)
}

export { getToken, setToken, clearToken, getUser, setUser, clearUser }
